/**
 * Descripción: Gestor de Store Vuex
 *
 * @displayName index
 */

import Vue from 'vue';
import Vuex from 'vuex';
import * as authentication from '@/store/modules/authentication.js';
import * as notification from '@/store/modules/notification.js';
import * as loading from '@/store/modules/loading.js';
import * as navbar from '@/store/modules/navbar.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    notification,
    authentication,
    loading,
    navbar
  }
});
